import XLSX from 'xlsx';


export function importExcel(file) {

    return new Promise((resolve, reject) => {

        let fileReader = new FileReader();

        fileReader.readAsBinaryString(file)

        fileReader.onload = (e) => {
            let { target: { result } } = e
            let workbook = XLSX.read(result, {type: 'binary'})

            workbook.SheetNames.forEach(sheet => {
                let data = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheet]);
            
                resolve(data)
            });
        }

        fileReader.onerror = (e) => reject(e);

    })

    
}